var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isTester())?_c('div',{staticClass:"premium-ad"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.cta)}}),_c('div',{staticClass:"more-info",on:{"click":_vm.onClickMoreInfo}},[_vm._v("더 알아보기")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }